import { render, staticRenderFns } from "./AlibeyBills.vue?vue&type=template&id=3a84dc54&scoped=true"
import script from "./AlibeyBills.vue?vue&type=script&lang=js"
export * from "./AlibeyBills.vue?vue&type=script&lang=js"
import style0 from "./AlibeyBills.vue?vue&type=style&index=0&id=3a84dc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84dc54",
  null
  
)

export default component.exports